import Spin from './Loading'

export default Spin

